export default {
  id: 'what-is-backtesting',
  title: 'What is Backtesting?',
  content: `## What is Backtesting?

Backtesting lets you test how a trading strategy would have performed on historical NSE market data — before you commit to running it live on the paper trading engine.

---

## Why Backtest?

A strategy that looks good in theory might perform poorly in practice. Backtesting reveals:
- Whether the conditions you defined actually produce profitable setups historically
- How often the strategy triggers (too frequent = noisy, too rare = unused)
- What the win rate and average R:R look like over many instances
- What the maximum drawdown was — how much capital it would have consumed at worst

Without backtesting, you are running an untested Algo Flow strategy on live data and finding out the hard way.

---

## How TradeLab's Backtesting Works

TradeLab uses a database of historical 1-minute candle data (\`market_data_live\`) covering the last 7 days of rolling intraday data, plus daily OHLCV data going back 90+ days.

When you run a backtest:
1. You define the strategy conditions (same as Algo Flows entry conditions)
2. You select a date range and target symbols
3. The engine replays historical candles day by day, evaluating your conditions at each point in time
4. When conditions would have triggered, a simulated trade is recorded with the outcome over the next N candles

The result is a performance summary showing how the strategy would have performed over that period.

---

## What Backtesting Cannot Tell You

- **Future performance** — past results do not guarantee future results
- **Execution quality** — real fills in live markets may differ from simulated fills
- **Regime changes** — a strategy that worked in a trending market may fail in a sideways one
- **Slippage and impact** — TradeLab does not model market impact of orders

> Backtesting is a filter, not a proof. A strategy that fails in backtesting should definitely be revised. A strategy that passes backtesting still requires live testing with caution.

---

## Backtesting vs ACT

| Backtesting | ACT |
|---|---|
| Tests a set of rules automatically | Tests your personal decision quality |
| Covers many historical instances at once | One scenario at a time |
| Evaluates Algo Flow conditions | Evaluates human judgment |
| Best for: validating rule-based strategies | Best for: improving trader behaviour |

Use both: ACT to improve your judgment, Backtesting to validate the rules you eventually automate.

---

## Where to Find It

**Profile → Backtesting**`,
};
